'use client';

import { useTranslations } from 'next-intl';
import {
  Delete02Icon,
  File01Icon,
  HierarchyIcon,
  SentIcon,
} from '@terra/ui-icons';
import { ListPageBulkActionButton } from '../../common/ListPageBulkActionButton';
import { ListPageSelectionBar } from '../../common/ListPageSelectionBar';

type FindingsBulkActionsBarProps = {
  selectedCount: number;
  isSubmitting: boolean;
  mutationsDisabledTooltip: string | null;
  canCreateChain?: boolean;
  onClearSelection: () => void;
  onGenerateReport: () => void;
  onCreateChain?: () => void;
  onPublish: () => void;
  onDelete: () => void;
};

export function FindingsBulkActionsBar({
  selectedCount,
  isSubmitting,
  mutationsDisabledTooltip,
  canCreateChain = false,
  onClearSelection,
  onGenerateReport,
  onCreateChain,
  onPublish,
  onDelete,
}: FindingsBulkActionsBarProps) {
  const t = useTranslations('findingsTab.row');
  const tSelection = useTranslations('proxy.findings.selectAllBanner');
  const isDisabled = isSubmitting || mutationsDisabledTooltip !== null;

  return (
    <ListPageSelectionBar
      selectedCount={selectedCount}
      clearSelectionLabel={tSelection('clearSelection')}
      onClearSelection={onClearSelection}
    >
      <ListPageBulkActionButton
        label={t('generateReport')}
        tooltip={mutationsDisabledTooltip ?? t('generateReport')}
        icon={<File01Icon size={12} />}
        isDisabled={isDisabled}
        onClick={onGenerateReport}
      />
      {canCreateChain && onCreateChain ? (
        <ListPageBulkActionButton
          label={t('createChain')}
          tooltip={t('createChain')}
          icon={<HierarchyIcon size={12} />}
          isDisabled={isSubmitting}
          onClick={onCreateChain}
        />
      ) : null}
      <ListPageBulkActionButton
        label={t('publish')}
        tooltip={mutationsDisabledTooltip ?? t('publish')}
        icon={<SentIcon size={12} />}
        isDisabled={isDisabled}
        onClick={onPublish}
      />
      <ListPageBulkActionButton
        label={t('delete')}
        tooltip={mutationsDisabledTooltip ?? t('delete')}
        icon={<Delete02Icon size={12} />}
        isDisabled={isDisabled}
        onClick={onDelete}
      />
    </ListPageSelectionBar>
  );
}
